import queryString from 'query-string';
import type { NskResponse } from '~/models/Api';
import { deleteRequest, postRequest } from '~/utils/api/api_handler';
import type {
  DealConstruction,
  DealConstructionEdit
} from '~/models/DealConstruction';
import { generatePath } from '~/utils/generatePath';
import { convertDealConstructionToPayload } from '~/utils/api/convertDealConstructionPayload';

export const create = async (
  dealEstimationHistory: DealConstructionEdit,
  dealId: number,
  dealEstimationId: number | null,
  id: number | null
): Promise<NskResponse<void>> =>
  postRequest(
    queryString.stringifyUrl({
      url: generatePath('/deals/:deal_id/deal_estimation_histories', {
        deal_id: dealId
      }),
      query: { deal_estimation_id: dealEstimationId, id, version: 'v2' }
    }),
    {
      dealEstimationHistory: convertDealConstructionToPayload(
        dealEstimationHistory
      )
    }
  );

// 一度承認された見積り項目は申請を通じて削除する
// operationTypeを'delete'にする
export const updateTypeDelete = async (
  dealId: number,
  dealEstimationId: number
): Promise<NskResponse<void>> =>
  postRequest(
    queryString.stringifyUrl({
      url: generatePath('/deals/:deal_id/deal_estimation_histories', {
        deal_id: dealId
      }),
      query: { deal_estimation_id: dealEstimationId, version: 'v2' }
    }),
    {
      dealEstimationHistory: {
        operationType: 'delete'
      }
    }
  );

// 承認前の項目を削除する場合は、申請を介す必要がないので、そのままデータを削除する
export const destroy = async (
  dealId: number,
  dealEstimationHistoryId: number
): Promise<NskResponse<void>> =>
  deleteRequest(
    generatePath('/deals/:deal_id/deal_estimation_histories/:id', {
      deal_id: dealId,
      id: dealEstimationHistoryId
    })
  );

export const updateSeq = async (
  dealEstimationHistories: DealConstruction[],
  dealId: number
): Promise<NskResponse<void>> =>
  postRequest(
    generatePath('/deals/:deal_id/deal_estimation_histories/update_seq', {
      deal_id: dealId
    }),
    {
      dealEstimationHistories
    }
  );
